"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyProfileMainContentEditModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_components_1 = require("styled-components");
const CompanyProfileMainContentEditForm_1 = __importDefault(require("./CompanyProfileMainContentEditForm"));
const CompanyProfileMainContentEditModal = ({ isEditModalOpen, setIsEditModalOpen, company }) => {
    const companyProfileHeaderFormRef = react_1.default.useRef(null);
    const [isSubmitting, setIsSubmitting] = react_1.default.useState(false);
    const intl = (0, react_intl_1.useIntl)();
    const theme = (0, styled_components_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(elements_1.Modal, { title: intl.formatMessage({ id: 'admin.company_premium_profile.edit_company_profile_body' }), visible: isEditModalOpen, width: theme.modalWidth.largeModal, onOk: () => { var _a; return (_a = companyProfileHeaderFormRef.current) === null || _a === void 0 ? void 0 : _a.submitForm(); }, okButtonProps: {
            loading: isSubmitting,
        }, onCancel: () => setIsEditModalOpen(false), children: (0, jsx_runtime_1.jsx)(CompanyProfileMainContentEditForm_1.default, { setIsModalOpen: setIsEditModalOpen, setIsSubmitting: setIsSubmitting, company: company, ref: companyProfileHeaderFormRef }) }));
};
exports.CompanyProfileMainContentEditModal = CompanyProfileMainContentEditModal;
